export enum EventType {
  InPerson = 'InPerson',
  VirtualEvent = 'VirtualEvent',
  Class = 'Class',
  NoneAbove = 'NoneAbove'
}
